"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconDelete = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M6 21 18 21 18 7 6 7 6 21ZM19 4 15.5 4 14.5 3 9.5 3 8.5 4 5 4 5 6 19 6 19 4Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconDelete')(IconDelete);